import { Title } from "../../../../../components/Title";
import claimPayIcon from '../../../../../assets/claim-pay-icon.svg';

export const WelcomeTitle = () => <Title title='Inspection Request'>
  <img alt='claimpay' src={claimPayIcon} />
</Title>